export default {
  V4_ID_PATTERN: 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx',
  V4_ID_REGEX: /[xy]/g,
  VENDORS: {
    APPLE: 'Apple'
  },
  USER_AGENTS: {
    ANDROID: 'Android',
    APPLE_WEBKIT: 'AppleWebKit',
    CHROME: 'Chrome',
    MOZILLA: 'Mozilla/5.0'
  }
};